import ymaps from 'yandex-maps';
import {ClinicsPlace, Nullable} from '../types';
import Slider from './Slider';
import {Swiper} from 'swiper';

interface IOverlay {
    getLayoutSync: () => ymaps.Layer;
}

interface MyBalloonLayout extends ymaps.layout.templateBased.Base {
    applyElementOffset?: any;
    _$element?: JQuery;
    onCloseClick?: any;
    _isElement?: (
        element: JQuery
    ) =>
        | HTMLSelectElement
        | HTMLLegendElement
        | HTMLElement
        | HTMLTableCaptionElement
        | HTMLTextAreaElement;
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/**
 * Класс по работе с картой
 */
export default class ClinicsMap {
    private DEFAULT_CENTR_COORDINATES = [55.751574, 37.573856];
    private ACTIVE_ITEM_CLASS = 'active';
    private HAS_ACTIVE_CLINIC_CLASS = 'has-active-clinic';
    private HIDDEN_BUTTONS = 'hidden-buttons';
    private selectors = {
        listItem: '.js-clinics-list-item',
        swiperClinic: '.js-clinic-slider',
    };

    private $holder: JQuery;
    private clinicsList: JQuery;
    private clinicsSlider: JQuery;
    private mapHolder: HTMLElement;
    private data: Nullable<ClinicsPlace>[];
    private balloonLayout: ymaps.IClassConstructor<ymaps.layout.templateBased.Base> | null =
        null;
    private mapInstance: ymaps.Map | null = null;
    private geoObjectsCollection: ymaps.GeoObjectCollection | null = null;
    private options = {
        initBounds: true,
    };
    private geoObjects:  ymaps.Placemark[] = [];
    private clusterer:  ymaps.Clusterer = null;
    public swiper;

    constructor($holder: JQuery, clinics: Nullable<ClinicsPlace>[]) {
        this.$holder = $holder;
        this.clinicsList = this.$holder.find('.js-clinics-list');
        this.clinicsSlider = this.$holder.find(this.selectors.swiperClinic);

        this.mapHolder = this.$holder
            .find('.js-map-holder')
            .get(0) as HTMLElement;
        this.data = clinics;

        this.clickListItemHandler = this.clickListItemHandler.bind(this);

        this.init();
    }

    private init(): void {
        this.showClinicsList();


        void window.ymaps.ready(() => {
            this.buildClustererMap();
        });
        this.swiper = new Slider(this.clinicsSlider.eq(0));
        this.swiper.swiper.on('slideChange', (swiper: Swiper) => {
            const $listItems = this.clinicsList.find('.js-clinics-list-item');
            const item = $listItems.eq(swiper.activeIndex);
            this.clickListItemHandler(item)
        })
        if (this.data.length  < 2) {
            this.clinicsSlider.addClass(this.HIDDEN_BUTTONS);
        }
    }


    /**
     * Строим карту
     * @private
     */
    private buildClustererMap(): void {

        let emptyCoordinates = 0;

        // Проходимся по всем точкам и создаём пины
        this.data.forEach((item, index) => {
            if (!item.latitude && !item.longitude) {
                emptyCoordinates++;
                return;
            }

            const placeMark = new window.ymaps.Placemark(
                [item.latitude, item.longitude],
                {
                    id: index,
                    name: item?.name ?? '',
                    address: item.address,
                    phone: item.phone,
                    siteUrl: item.site,
                    site: this.replaceUrlMath(item.site),
                    image: item.image,
                },
                {
                    hideIconOnBalloonOpen: false,
                    // balloonLayout: this.createBalloonLayout(),
                    // balloonContentLayout: this.createBalloonContent(),
                    // balloonPanelMaxMapArea: 0,
                    iconLayout: this.createPinLayout(),
                    iconOffset: [-20, -25],
                    pointOverlay: 'html#placemark',
                }
            );

            this.geoObjects.push(placeMark);

            // События метки на карте
            placeMark.events
                .add(
                    'balloonopen',
                    (e: { get: (property: string) => ymaps.GeoObject }) => {
                        const mark = e.get('target');
                        const markDom = this.getMarkDom(mark);
                        const balloonPosition = placeMark.balloon.getPosition();
                        const $balloon = $('.js-map-balloon');

                        const balloonRect = (
                            $balloon.get(0) as HTMLElement
                        ).getBoundingClientRect();

                        if (!markDom) {
                            return;
                        }

                        $(markDom)
                            .find('.js-map-pin-custom')
                            .addClass('active');

                        if (!this.mapInstance) {
                            return;
                        }

                        const globalPixelCenter = [
                            (balloonPosition as number[])[0],
                            (balloonPosition as number[])[1] +
                            balloonRect.height / 2,
                        ];

                        void this.mapInstance.setGlobalPixelCenter(
                            globalPixelCenter,
                            this.mapInstance.getZoom(),
                            {
                                duration: 300,
                            }
                        );
                    }
                )
                .add(
                    'hover',
                    (e: { get: (property: string) => ymaps.GeoObject }) => {
                        const mark = e.get('target');

                        const markDom = this.getMarkDom(mark);

                        if (!markDom) {
                            return;
                        }
                        $(markDom).find('.js-map-pin-custom').addClass('hover');
                    }
                )
                .add(
                    'click',
                    (e: { get: (property: string) => ymaps.GeoObject }) => {
                        const mark = e.get('target');

                        const markDom = this.getMarkDom(mark);

                        this.disableAllActiveItems();

                        if (!markDom) {
                            return;
                        }

                        $(markDom)
                            .find('.js-map-pin-custom')
                            .addClass(this.ACTIVE_ITEM_CLASS);
                        this.swiper.swiper.slideTo(index)
                        this.clinicsList
                            .find(this.selectors.listItem)
                            .eq(index)
                            .addClass(this.ACTIVE_ITEM_CLASS);
                        this.scrollToPlace(index);

                        this.clinicsList.addClass(this.HAS_ACTIVE_CLINIC_CLASS);
                    }
                )
                .add(
                    'mouseleave',
                    (e: { get: (property: string) => ymaps.GeoObject }) => {
                        const mark = e.get('target');
                        const markDom = this.getMarkDom(mark);

                        if (!markDom) {
                            return;
                        }

                        $(markDom)
                            .find('.js-map-pin-custom')
                            .removeClass('hover');
                    }
                );
        });

        const points = this.geoObjects.map((point) => {
            const geometry = point.geometry;

            if (!geometry) {
                return null;
            }

            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-call
            return geometry.getCoordinates();
        });

        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        const bounds = window.ymaps.util.bounds.fromPoints(points);


        const clusterBalloonCustomContentLayout = this.createClusterBalloonContent();

        this.clusterer = new window.ymaps.Clusterer({
            hasBalloon: true,
            // @ts-ignore
            clusterIconLayout: window.ymaps.templateLayoutFactory.createClass('<div style="background-color: #4BB5B3; width: 48px; height: 48px; border-radius: 100%; display: flex; justify-content: center; align-items: center; color: #FFFFFF;">{{ properties.geoObjects.length }}</div>'),
            clusterIconShape: {
                type: 'Circle',
                coordinates: [24, 24],
                radius: 24
            },
            clusterBalloonContentLayout: clusterBalloonCustomContentLayout,
            clusterBalloonLayout: this.createBalloonLayout(),
        });

        this.clusterer.add(this.geoObjects);

        this.clusterer.events.add('balloonopen', function (e) {
            const $balloon = $('.js-map-balloon');
            const isClusterBalloon = !!($balloon.find('.js-balloon-cluster').length);
            if (isClusterBalloon) {
                $balloon.addClass('map-balloon--cluster');
            }
        });

        this.geoObjectsCollection = new window.ymaps.GeoObjectCollection();
        // @ts-ignore
        this.geoObjectsCollection.add(this.clusterer);

        this.mapInstance = new window.ymaps.Map(
            this.mapHolder,
            {
                behaviors: ['default', 'scrollZoom'],
                bounds,
                controls: [],
            },
            {
                autoFitToViewport: 'always',
            }
        );

        this.mapInstance?.geoObjects.add(this.geoObjectsCollection);

        if (this.options.initBounds) {
            void this.mapInstance?.setBounds(
                this.mapInstance?.geoObjects.getBounds() as number[][],
                {
                    checkZoomRange: true,
                    zoomMargin: [50],
                }
            );
        }
    }

    private scrollToPlace(itemId: number): void {
        const coordinatesFirst = this.clinicsList
            .children()
            .eq(0)
            .offset() as JQuery.Coordinates;
        const coordinatesTarget = this.clinicsList
            .children()
            .eq(itemId)
            .offset() as JQuery.Coordinates;
        const coordinatesList =
            this.clinicsList.offset() as JQuery.Coordinates;
        const scrollTop: number = coordinatesFirst.top - coordinatesList.top;
        const scrollTarget: number =
            coordinatesTarget.top - coordinatesList.top;
        const scrollOffset: number = scrollTarget - scrollTop - 10;
    }

    private searchPlaceMark(id: number): unknown {
        let geoObject = this.geoObjects;

        return geoObject.find((item) => {
            // @ts-ignore
            return item.properties._data.id === id
        });
    }

    /**
     * Получить dom точки на карте
     * @param mark
     * @private
     */
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    private getMarkDom(
        mark: ymaps.IGeoObject<ymaps.IGeometry>
    ): HTMLElement | null {

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const overlay = mark.getOverlaySync() as IOverlay;

        if (!overlay) {
            return null;
        }

        return overlay.getLayoutSync().getElement();
    }

    /**
     * Создать лайаут балуна
     * @private
     */
    private createBalloonLayout(): ymaps.IClassConstructor<MyBalloonLayout> {
        if (this.balloonLayout) {
            return this.balloonLayout;
        }

        const MyBalloonLayout: ymaps.IClassConstructor<ymaps.layout.templateBased.Base> =
            window.ymaps.templateLayoutFactory.createClass(
                `<div class="map-balloon js-map-balloon">
                        $[[options.contentLayout]]
                        <a class="map-balloon-close js-close" href="#"></a>
                    </div>`,
                {
                    build: function (this: MyBalloonLayout): void {
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call
                        MyBalloonLayout.superclass.build.call(this);
                        this._$element = $(
                            '.js-map-balloon',
                            this.getParentElement()
                        );

                        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                        this.applyElementOffset();
                        this._$element
                            .find('.js-close')
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                            .on('click', $.proxy(this.onCloseClick, this));

                        const $itemsInBalloon = this._$element.find('.js-cluster-balloon-item');
                        const $itemsBalloonContent = this._$element.find('.js-cluster-balloon-content');
                        const $clinicsList = $('.js-clinics-list');
                        const $listItems = $clinicsList.find('.js-clinics-list-item');

                        const scrollToPlace = (itemId: number) => {
                            const coordinatesFirst = $clinicsList
                                .children()
                                .eq(0)
                                .offset() as JQuery.Coordinates;
                            const coordinatesTarget = $clinicsList
                                .children()
                                .eq(itemId)
                                .offset() as JQuery.Coordinates;
                            const coordinatesList =
                                $clinicsList.offset() as JQuery.Coordinates;
                            const scrollTop: number = coordinatesFirst.top - coordinatesList.top;
                            const scrollTarget: number =
                                coordinatesTarget.top - coordinatesList.top;
                            const scrollOffset: number = scrollTarget - scrollTop - 10;

                            $clinicsList.animate({ scrollTop: scrollOffset }, 'slow');
                        }


                        if ($itemsInBalloon.length) {
                            $itemsInBalloon.eq(0).addClass('active');
                            $itemsBalloonContent.eq(0).addClass('active');

                            $listItems.removeClass('active');
                            $listItems.eq(0).addClass('active');
                            $clinicsList.addClass('has-active-clinic');
                            scrollToPlace(0);

                            this._$element.find('.js-cluster-balloon-item').on('click', (event) => {
                                $itemsInBalloon.removeClass('active');
                                $itemsBalloonContent.removeClass('active');

                                $(event.currentTarget).addClass('active');

                                const index = $(event.currentTarget).index();
                                $itemsBalloonContent.eq(index).addClass('active');


                                $listItems.removeClass('active');
                                $listItems.eq(index).addClass('active');
                                scrollToPlace(index);
                            });
                        }
                    },
                    clear: function (this: MyBalloonLayout): void {
                        this._$element?.find('.js-close').off('click');
                        this._$element?.find('.js-close').off('click');
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call
                        MyBalloonLayout.superclass.clear.call(this);
                    },
                    onSublayoutSizeChange: function (this: MyBalloonLayout) {
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call
                        MyBalloonLayout.superclass.onSublayoutSizeChange.apply(
                            this,
                            // eslint-disable-next-line prefer-rest-params
                            arguments
                        );
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        if (!this._isElement(this._$element)) {
                            return;
                        }
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                        this.applyElementOffset();
                        this.events.fire('shapechange');
                    },
                    applyElementOffset: function (this: MyBalloonLayout) {
                        this._$element?.css({});
                    },
                    onCloseClick: function (e: Event) {
                        e.preventDefault();
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call
                        this.events.fire('userclose');
                        const $pinHolder = $('.js-map-pin-custom');
                        $pinHolder.removeClass('active');

                        const $listItems = $('.js-clinics-list-item');
                        $listItems.removeClass('active');

                        const clinicsList = $('.js-clinics-list')
                        clinicsList.removeClass('has-active-clinic');
                    },
                    getShape: function (this: MyBalloonLayout): unknown {
                        if (!this._isElement || !this._$element) return;

                        if (!this._isElement(this._$element)) {
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call
                            return MyBalloonLayout.superclass.getShape.call(
                                this
                            );
                        }
                        const position = this._$element?.position();
                        if (position && this._$element) {
                            const rect =
                                new window.ymaps.geometry.pixel.Rectangle([
                                    [position.left, position.top],
                                    [
                                        position.left +
                                            this._$element[0].offsetWidth,
                                        position.top +
                                            this._$element[0].offsetHeight,
                                    ],
                                ]);
                            return new window.ymaps.shape.Rectangle(rect);
                        }
                        return;
                    },
                    _isElement: function (element: JQuery) {
                        return (
                            element && element[0] && element.find('.arrow')[0]
                        );
                    },
                }
            );

        this.balloonLayout = MyBalloonLayout;

        return MyBalloonLayout;
    }

    /**
     * Создать лайаут контента балуна
     * @private
     */
    private createBalloonContent(): ymaps.IClassConstructor<ymaps.layout.templateBased.Base> {
        return window.ymaps.templateLayoutFactory.createClass(
            `
            <div class="map-balloon__wrapper">
            {% if properties.image %}
                <div class="map-balloon__image">
                    <img src="$[properties.image]"  alt=""/>
                </div>
            {% endif %}
            <div class="map-balloon__content">
                {% if properties.name %}
                    <p class="map-balloon__title h4">$[properties.name]</p>
                {% endif %}
                {% if properties.siteUrl %}
                    <a href="$[properties.siteUrl]" target="_blank" class="map-balloon__site h6">$[properties.site]</a>
                {% endif %}
                {% if properties.phone %}
                    <div class="map-balloon__telephone">
                        <p class="map-balloon__telephone-label label">телефон</p>
                        <p class="map-balloon__telephone-number h6">$[properties.phone]</p>
                    </div>
                {% endif %}
                {% if properties.address %}
                    <div class="map-balloon__address">
                        <p class="map-balloon__address-label label">адресс</p>
                        <p class="map-balloon__address-number h6">$[properties.address]</p>
                    </div>
                {% endif %}
            </div>
            </div>`
        );
    }

    private createClusterBalloonContent(): ymaps.IClassConstructor<ymaps.layout.templateBased.Base>  {
       return window.ymaps.templateLayoutFactory.createClass(
            `
                 <div class="map-balloon__cluster-container js-balloon-cluster">
                      <div class="map-balloon__cluster-list">
                          {% for geoObject in properties.geoObjects %}
                              <div class="map-balloon__cluster-item js-cluster-balloon-item">
                                   <p class="map-balloon__title h4">$[geoObject.properties.name]</p>
                              </div>
                          {% endfor %}
                      </div>
                     <div class="map-balloon__cluster-content">
                         {% for geoObject in properties.geoObjects %}
                            <div class="map-balloon__wrapper js-cluster-balloon-content">
                                {% if geoObject.properties.image %}
                                    <div class="map-balloon__image">
                                        <img src="$[geoObject.properties.image]"  alt=""/>
                                    </div>
                                {% endif %}
                                <div class="map-balloon__content">
                                    {% if geoObject.properties.name %}
                                        <p class="map-balloon__title h4">$[geoObject.properties.name]</p>
                                    {% endif %}
                                    {% if geoObject.properties.siteUrl %}
                                        <a href="$[geoObject.properties.siteUrl]" target="_blank" class="map-balloon__site h6">$[geoObject.properties.site]</a>
                                    {% endif %}
                                    {% if geoObject.properties.phone %}
                                        <div class="map-balloon__telephone">
                                            <p class="map-balloon__telephone-label label">телефон</p>
                                            <p class="map-balloon__telephone-number h6">$[geoObject.properties.phone]</p>
                                        </div>
                                    {% endif %}
                                    {% if geoObject.properties.address %}
                                        <div class="map-balloon__address">
                                            <p class="map-balloon__address-label label">адрес</p>
                                            <p class="map-balloon__address-number h6">$[geoObject.properties.address]</p>
                                        </div>
                                    {% endif %}
                                </div>
                            </div>
                        {% endfor %}
                     </div>
                </div>
            `
        );
    }

    /**
     * Создать лайаут пина
     * @private
     */
    private createPinLayout() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return window.ymaps.templateLayoutFactory.createClass(
            `<div class="map-pin-custom js-map-pin-custom">
                    <svg width="37" height="45" viewBox="0 0 37 45" xmlns="http://www.w3.org/2000/svg">
                        <path d="M29.436 5.09789C27.3612 3.39902 24.9352 2.18179 22.3329 1.534C19.7307 0.886215 17.0172 0.824016 14.388 1.35189C11.0075 2.04497 7.8974 3.69519 5.42828 6.10599C2.95916 8.51678 1.23508 11.5865 0.461397 14.9495C-0.312284 18.3125 -0.102947 21.8271 1.06447 25.0745C2.23189 28.3219 4.30818 31.1652 7.04601 33.2659C10.1719 35.5537 12.8333 38.4161 14.888 41.6999L16.288 44.0279C16.4658 44.3236 16.7171 44.5683 17.0174 44.7381C17.3178 44.908 17.657 44.9973 18.002 44.9973C18.3471 44.9973 18.6862 44.908 18.9866 44.7381C19.2869 44.5683 19.5382 44.3236 19.716 44.0279L21.058 41.7919C22.8472 38.6466 25.2869 35.9193 28.214 33.7919C30.5092 32.2127 32.4061 30.1218 33.7549 27.6841C35.1037 25.2465 35.8676 22.5287 35.9863 19.7452C36.105 16.9618 35.5752 14.1888 34.4388 11.6452C33.3024 9.10149 31.5905 6.85669 29.438 5.08789L29.436 5.09789ZM18 26.9999C16.4178 26.9999 14.871 26.5307 13.5555 25.6516C12.2399 24.7726 11.2145 23.5232 10.609 22.0614C10.0035 20.5996 9.84505 18.991 10.1537 17.4392C10.4624 15.8873 11.2243 14.4619 12.3432 13.343C13.462 12.2242 14.8874 11.4623 16.4393 11.1536C17.9911 10.8449 19.5997 11.0034 21.0615 11.6089C22.5233 12.2144 23.7727 13.2397 24.6518 14.5553C25.5308 15.8709 26 17.4176 26 18.9999C26 21.1216 25.1572 23.1565 23.6569 24.6567C22.1566 26.157 20.1217 26.9999 18 26.9999Z"/>
                    </svg>
                </div>`,
            {
                getShape: function () {
                    const ctx = this as unknown as {
                        getElement: () => HTMLElement | null;
                    };

                    const elem: HTMLElement = ctx.getElement() as HTMLElement;

                    if (!elem) {
                        return null;
                    }

                    const icon: HTMLElement | null =
                        elem.firstChild as HTMLElement;

                    if (!icon) {
                        return null;
                    }

                    return new window.ymaps.shape.Rectangle(
                        new window.ymaps.geometry.pixel.Rectangle([
                            [icon.offsetLeft, icon.offsetTop],
                            [
                                icon.offsetLeft + icon.offsetWidth,
                                icon.offsetTop + icon.offsetHeight,
                            ],
                        ])
                    );
                },
            }
        );
    }


    /**
     * Создать лайаут пина
     * @private
     */
    private createZoomLayout() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const ZoomLayout: ymaps.IClassConstructor<ymaps.layout.templateBased.Base> =
            window.ymaps.templateLayoutFactory.createClass("<div class='map-controls-container'>" +
            "<div id='zoom-in' class='map-controls map-controls--zoom-in'></div>" +
            "<div id='zoom-out' class='map-controls map-controls--zoom-out'></div>" +
            "</div>", {

            // Переопределяем методы макета, чтобы выполнять дополнительные действия
            build: function () {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call
                ZoomLayout.superclass.build.call(this);

                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call
                this.zoomInCallback = window.ymaps.util.bind(this.zoomIn, this);
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call
                this.zoomOutCallback = window.ymaps.util.bind(this.zoomOut, this);

                // Начинаем слушать клики на кнопках макета.
                $('#zoom-in').bind('click', this.zoomInCallback);
                $('#zoom-out').bind('click', this.zoomOutCallback);
            },

            clear: function () {
                // Снимаем обработчики кликов.
                $('#zoom-in').unbind('click', this.zoomInCallback);
                $('#zoom-out').unbind('click', this.zoomOutCallback);

                // Вызываем родительский метод clear.
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call
                ZoomLayout.superclass.clear.call(this);
            },

            zoomIn: function () {
                var map = this.getData().control.getMap();
                map.setZoom(map.getZoom() + 1, {checkZoomRange: true});
            },

            zoomOut: function () {
                var map = this.getData().control.getMap();
                map.setZoom(map.getZoom() - 1, {checkZoomRange: true});
            }
        });

        return ZoomLayout;
    }

    private disableAllActiveItems(): void {
        const $listItems = this.clinicsList.find(this.selectors.listItem);
        $listItems.removeClass(this.ACTIVE_ITEM_CLASS);
        this.clinicsList.removeClass(this.HAS_ACTIVE_CLINIC_CLASS);

        const $pinHolder = $('.js-map-pin-custom');
        $pinHolder.removeClass('active');
    }

    private clickListItemHandler(item: JQuery): void {
        this.disableAllActiveItems();

        const $target = $(item);
        const indexItem = $target.index();

        const geoObject = this.searchPlaceMark(indexItem) as ymaps.GeoObject;

        const markDom = this.getMarkDom(geoObject);

        if (markDom) {
            const $pinHolder = $(markDom).find('.js-map-pin-custom');
            $pinHolder.addClass(this.ACTIVE_ITEM_CLASS);
        }

        $target.addClass(this.ACTIVE_ITEM_CLASS);
        this.clinicsList.addClass(this.HAS_ACTIVE_CLINIC_CLASS);

        const clinicsItem = this.data[indexItem];
        if (this.mapInstance && clinicsItem) {
            const coordinates = [+clinicsItem.latitude, +clinicsItem.longitude];

            void this.mapInstance.setCenter(coordinates, 18, {
                duration: 300,
            }).then(() => {
                if (geoObject) {
                    // void geoObject.balloon.open();
                } else {
                    this.closeAllBalloons();
                }
            });
        }
    }

    /**
     * Закрыть все балуны на карте
     */
    private closeAllBalloons(): void {
        if (typeof this.mapInstance !== 'undefined') {
            void this.mapInstance?.balloon.close();
        }
    }

         /**
     * Вывод локаций в виде списка
     */
    private showClinicsList(): void {
        // Очистка и заполнение списка
        if (!this.data) {
            return;
        }

        this.clinicsList
            .empty()
            .append(this.data.map((clinic, placeIndex) => {
                return $(
                    `<li class="clinic-list-item swiper-slide js-slider-item js-clinics-list-item">
                            <div class="clinic-list-item__wrapper">
                                <p class="clinic-list-item__title h4">${clinic.name ?? ' '}</p>
                                <div class="clinic-list-item__telephone">
                                    <span class="clinic-list-item__telephone-label label">телефон</span>
                                    <span class="clinic-list-item__telephone-number h6">${clinic.phone ?? ''}</span>
                                </div>
                                <p class="clinic-list-item__address">
                                    <span class="clinic-list-item__address-label label">Адрес</span>
                                    <span class="clinic-list-item__address-text h6">${clinic.address ?? ''}</span>
                                </p>
                            </div>
                        </li>`
                );
            }));
    }

    /**
     * Убрать из строки http/https//
     * @param url
     * @private
     */
    private replaceUrlMath(url: string): string
    {
        if (!url) {
            return url;
        }
        return url.split('://')[1];
    }


    /**
     * Убрать из строки http/https//
     * @private
     */
    public destroyMap(): void
    {
        this.$holder.find('.js-map-holder').empty();
        this.mapInstance = null;
        this.clinicsList.removeClass(this.HAS_ACTIVE_CLINIC_CLASS);
        // @ts-ignore
        this.clinicsList.off('click', this.selectors.listItem, this.clickListItemHandler);
    }
}
